/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Subscription_ExpiredInputs */

const cs_billing_subscription_expired = /** @type {(inputs: Billing_Subscription_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předplatné vypršelo. Obnovte plán pro úpravy a import.`)
};

const en_billing_subscription_expired = /** @type {(inputs: Billing_Subscription_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your subscription has expired. Upgrade to continue editing and importing.`)
};

/**
* | output |
* | --- |
* | "Your subscription has expired. Upgrade to continue editing and importing." |
*
* @param {Billing_Subscription_ExpiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_subscription_expired = /** @type {((inputs?: Billing_Subscription_ExpiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Subscription_ExpiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_subscription_expired(inputs)
	return cs_billing_subscription_expired(inputs)
});